var map = {
	"./analisis-de-data": [
		71562,
		1562
	],
	"./analisis-de-data.ts": [
		71562,
		1562
	],
	"./digital-mindset": [
		34674,
		4674
	],
	"./digital-mindset.ts": [
		34674,
		4674
	],
	"./e-commerce": [
		86745,
		6745
	],
	"./e-commerce.ts": [
		86745,
		6745
	],
	"./innovacion": [
		97005,
		7005
	],
	"./innovacion.ts": [
		97005,
		7005
	],
	"./liderazgo": [
		9366,
		9366
	],
	"./liderazgo.ts": [
		9366,
		9366
	],
	"./marketing-digital": [
		16927,
		6927
	],
	"./marketing-digital.ts": [
		16927,
		6927
	],
	"./types": [
		1384,
		1384
	],
	"./types.ts": [
		1384,
		1384
	],
	"./ui-ux": [
		58751,
		8751
	],
	"./ui-ux.ts": [
		58751,
		8751
	],
	"./ventas": [
		10835,
		835
	],
	"./ventas.ts": [
		10835,
		835
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 58557;
module.exports = webpackAsyncContext;